module.exports = __webpack_public_path__ + "static/media/Global M3 CNG.928a0621.png";